var MediaManagerMediaType = /* @__PURE__ */ ((MediaManagerMediaType2) => {
  MediaManagerMediaType2["IMAGE"] = "IMAGE";
  MediaManagerMediaType2["ALL_MEDIA"] = "ALL_MEDIA";
  MediaManagerMediaType2["VIDEO"] = "VIDEO";
  MediaManagerMediaType2["AUDIO"] = "MUSIC";
  return MediaManagerMediaType2;
})(MediaManagerMediaType || {});
const createMediaMangerOpener = (mediaManagerInstance) => {
  return async ({
    mediaType,
    isMultiSelect,
    appDefId,
    onSuccess
  }) => {
    if ("editor" in mediaManagerInstance) {
      await mediaManagerInstance.editor.openMediaPanel("", {
        mediaType,
        isMultiSelect
      }).then(onSuccess);
    } else {
      mediaManagerInstance.invoke("mediaManager.open", mediaType, appDefId || "", {
        multiSelect: isMultiSelect,
        onSuccess: (data) => onSuccess(data.items)
      });
    }
  };
};
export {
  MediaManagerMediaType,
  createMediaMangerOpener
};
//# sourceMappingURL=mediaManagerPanel.js.map
